<template>
  <div class="section-container">

    <!-- Header with Add Button -->
    <b-row align-v="center" class="mb-2">
      <b-col md="12">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-uppercase font-weight-bold mb-0" style="display: flex; align-items: center">
            <i class="fas fa-medal mr-2" style="font-size: 20px !important;"></i> Positions Held / Other Responsibilities
          </h5>
          <b-button size="sm" variant="info" @click="showAddModal">
            <i class="fas fa-plus mr-1" style="font-size: 12px !important;"></i> Add
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-row v-if="positions && positions.length > 0" align-v="center" class="mb-3">
      <b-col md="12">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No.</th>
              <th>Description</th>
              <th>Academic Year</th>
              <th>Period</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="position in sortedPositions" :key="position.id">
              <td>{{ position.si_no }}</td>
              <td>{{ position.description }}</td>
              <td>{{ position.academic_year }}</td>
              <td>{{ position.period }}</td>
              <td>
                <i class="fas fa-edit pointer text-info mr-2" style="font-size: 18px !important;"
                  @click="editPosition(position)"></i>
                <i class="fas fa-trash fa-sm" style="cursor: pointer; color: #dc3545;"
                  @click="deletePosition(position)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <!-- Modal -->
    <b-modal v-model="showModal" title="Positions Held / Other Responsibilities" @hide="resetForm" hide-footer>
      <b-form @submit.prevent="createOrUpdatePosition">
        <b-form-group label="Sl No">
          <b-form-input v-model="position.si_no" type="number"></b-form-input>
        </b-form-group>
        <b-form-group label="Description">
          <b-form-input v-model="position.description"></b-form-input>
        </b-form-group>
        <b-form-group label="Academic Year">
          <b-form-input v-model="position.academic_year"></b-form-input>
        </b-form-group>
        <b-form-group label="Period">
          <b-form-input v-model="position.period"></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Save</b-button>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
export default {
  props: ["profile", "profileId"],
  data() {
    return {
      showModal: false,
      editIndex: null,
      position: { si_no: "", description: "", academic_year: "", period: "" },
      positions: this.profile.positions || [],
    };
  },
  computed: {
    sortedPositions() {
      return [...this.positions].sort((a, b) => Number(a.si_no) - Number(b.si_no));
    }
  },
  methods: {
    async createOrUpdatePosition() {
      try {
        const url = this.$store.getters.getAPIKey.mainAPI + `/userprofiles/positions`;
        let response;

        if (this.editIndex === null) {
          // Create new
          response = await this.$axios.post(url, {
            si_no: Number(this.position.si_no),
            description: this.position.description,
            academic_year: this.position.academic_year,
            period: this.position.period,
            user_profile_id: this.profile.id,
          });
          this.positions.unshift(response.data);
        } else {
          // Update existing
          const updateUrl = `${url}/${this.position.id}`;
          response = await this.$axios.put(updateUrl, {
            si_no: Number(this.position.si_no),
            description: this.position.description,
            academic_year: this.position.academic_year,
            period: this.position.period,
          });
          this.positions.splice(this.editIndex, 1, response.data);
        }

        this.$toast.success("Profile Updated", { position: "top", duration: 3000 });
        this.getProfile();
        this.showModal = false;
      } catch (error) {
        console.error("Error updating position:", error);
        this.$toast.error("Failed to update profile", { position: "top", duration: 3000 });
      }
    },

    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile.positions = response.data.positions;
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },

    showAddModal() {
      this.resetForm();
      this.showModal = true;
    },

    editPosition(position) {
      this.position = { ...position };
      this.editIndex = this.positions.findIndex(i => i.id === position.id);
      this.showModal = true;
    },

    async deletePosition(position) {
      try {
        const deleteUrl = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/positions/${position.id}`;
        await this.$axios.delete(deleteUrl);
        const index = this.positions.findIndex(i => i.id === position.id);
        if (index !== -1) {
          this.positions.splice(index, 1);
        }
        this.getProfile();
        this.$toast.success("position deleted", { position: "top", duration: 3000 });
      } catch (error) {
        console.error("Error deleting position:", error);
        this.$toast.error("Failed to delete position", { position: "top", duration: 3000 });
      }
    },

    resetForm() {
      this.position = { si_no: "", description: "", academic_year: "", period: "" };
      this.editIndex = null;
    }
  }
};
</script>

<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
</style>
